import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Layout from "../../components/Layout.js";
import Select from "react-select";

const OtherMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const [Otheraccode, setOtheraccode] = useState("");
  const [Otheraccodelist, setOtheraccodelist] = useState([]);
  const [Description, setDescription] = useState("");
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const [unqid, setUnqid] = useState("");
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "45px",
      height: "45px",
      borderRadius: "6px",
      borderColor: "#ccc",
      boxShadow: "none",
      fontSize: "15px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "45px",
      padding: "0 12px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "45px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };

  const inputStyle = (error) => ({
    padding: "12px 15px",
    height: "45px",
    marginTop: "5px",
    borderRadius: "6px",
    border: error ? "2px solid red" : "1px solid #ccc",
    width: "100%",
    fontSize: "15px",
    boxSizing: "border-box",
    backgroundColor: "#fff",
  });

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap", // mobile friendly
    width: "100%",
    marginTop: "20px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px", // ✅ same width everywhere
    height: "42px",
    padding: "0 20px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    whiteSpace: "nowrap", // ✅ no text breaking
  });
  useEffect(() => {
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
    setUserId(storedUserInfo.userId || "");
  }, []);

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);
  //--------Exit Working
  const handleExit = () => {
    navigate("/OtherMasterGrid");
  };

  //----Fetch Other
  useEffect(() => {
    fetchotherlist();
  }, []);
  const fetchotherlist = async () => {
    try {
      const response = await apiFetch(
        "/api/other-master/list",
      );
      const data = await response.json();
      const list = data.map((item) => ({
        label: item.value,
        value: item.data,
      }));
      setOtheraccodelist(list);
    } catch (error) {
      console.error("Error fetching other code:", error);
    }
  };
  //----Save Other
  const handleSave = async () => {
    let newErrors = {};
    if (!Description) newErrors.Description = true;
    if (!Otheraccode) newErrors.Otheraccode = true;
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;
    try {
      const response = await apiFetch(
        "/api/other-master/save",
        {
          method: "POST",
          body: JSON.stringify({
            description: Description,
            otherAcCode: Otheraccode,
            userId,
            ipAddress,
            serverIp,
          }),
        },
      );
      const data = await response.json();
      if (data.err === "0") {
        alert("Saved successfully");
        setDescription("");
        setOtheraccode("");
        fetchotherlist();
      } else {
        alert(data.msg);
      }
      navigate("/OtherMasterGrid");
    } catch (error) {
      console.error(error);
      alert("Error while saving");
    }
  };
  //--------Edit Working
  useEffect(() => {
    if (location.state?.unqid) {
      setIsEditMode(true);
      fetchEditData(location.state.unqid);
    }
  }, []);
  const fetchEditData = async (id) => {
    setUnqid(id);
    try {
      const res = await apiFetch(
        `/api/other-master/edit/${id}`,
      );
      const data = await res.json();
      if (data.err === "0") {
        setDescription(data.data.descr);
        setOtheraccode(data.data.other);
      }
    } catch (error) {
      console.error("Edit fetch failed", error);
    }
  };
  //----------Update Working
  const handleUpdate = async () => {
    let newErrors = {};
    if (!Description) newErrors.Description = true;
    if (!Otheraccode) newErrors.Otheraccode = true;
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    try {
      const response = await apiFetch(
        "/api/other-master/update",
        {
          method: "POST",
          body: JSON.stringify({
            unqid,
            description: Description,
            otherAcCode: Otheraccode,
          }),
        },
      );
      const data = await response.json();
      if (data.err === "0") {
        alert("Updated successfully");
        navigate("/OtherMasterGrid");
      } else {
        alert(data.msg);
      }
    } catch (error) {
      console.error(error);
      alert("Error while updating");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Other Master</div>

          {/* Form Section */}
          <div className="form-row">
            <div className="form-column">
              <label>Description</label>
              <input
                type="text"
                value={Description}
                onChange={(e) => setDescription(allowAlphabets(e.target.value))}
                style={inputStyle(errors.Description)}
              />
            </div>

            <div className="form-column">
              <label>Other A/C Code</label>
              <Select
                classNamePrefix="rs"
                options={Otheraccodelist}
                value={
                  Otheraccodelist.find((o) => o.value === Otheraccode) || null
                }
                onChange={(selected) => setOtheraccode(selected?.value || "")}
                styles={customStyles}
                placeholder="Select"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
          </div>

          {/* Buttons */}
          <div style={buttonContainerStyle}>
            {!isEditMode && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditMode && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}

            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      <style>
        {`
/* ================================
   react-select FIX
================================ */
.rs__menu-portal {
  z-index: 9999 !important;
}

/* ================================
   PAGE LAYOUT
================================ */
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  box-sizing: border-box;
}

/* ================================
   HEADER
================================ */
.header {
  text-align: center;
  font-size: 1.6rem;
  font-weight: 700;
  padding: 14px;
  background: linear-gradient(90deg, #8B1E3F, #8B1E3F);
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ================================
   FORM GRID
================================ */
.form-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 18px;
}

.form-column {
  display: flex;
  flex-direction: column;
}

.form-column label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
}

/* ================================
   BUTTONS
================================ */
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 22px;
  flex-wrap: wrap;
}

/* ================================
   RESPONSIVE
================================ */

/* Tablet */
@media (max-width: 992px) {
  .form-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* Mobile */
@media (max-width: 480px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .header {
    font-size: 1.3rem;
  }

  .button-container button {
    flex: 1;
  }
}
`}
      </style>
    </Layout>
  );
};

export default OtherMasterDetailsDesign;
